/** CLOS-13488 — post-checkout navigation target for MA order confirmation. */
export function buildMaOrderConfirmationRedirect(
  orderId: string,
  options: {
    from?: string
    programId?: string
    patientId?: number
  } = {}
) {
  return {
    pathname: `/order/${orderId}`,
    state: {
      from: options.from ?? '/orders',
      displayAnnounceOrderSuccess: true as const,
      ...(options.programId !== undefined && { programId: options.programId }),
      ...(options.patientId !== undefined && { patientId: options.patientId })
    }
  }
}
